export default {
  QuickSearch: {
    Title: 'Tìm nhân viên',
  },
  code: 'Mã nhân viên',
  name: 'Họ và tên',
  dob: 'Ngày sinh',
  address: 'Địa chỉ',
  inactive: 'Ngừng kích hoạt',
  gender: 'Giới tính',
  salary: 'Lương',
  List: {
    Title: 'Nhân viên',
    AddBtn: 'Thêm',
    AddNewBtn: 'Thêm mới',
    HelpBtn: 'Hướng dẫn',
    SearchEmptyText: 'Tìm kiếm',
    ActionColumn: 'Chức năng',
    SendPrintForm: 'Gửi mẫu in',
  },
  Detail: {
    Approve: 'Đồng ý',
    Save: 'Lưu',
    Cancel: 'Hủy',
  },
  Report: {
    Cancel: 'Hủy',
    ViewReport: 'Xem báo cáo',
  },
  Estimate: {
    Sync: 'Đồng bộ',
    Estimate: 'Lập dự toán',
  },
};
